export type CellFormatter<T = any> = (value: T | null | undefined) => string;

export const formatCellValue = <T>(value: T | null | undefined, formatter?: CellFormatter<T>): string => {
  const placeholder = "--";

  if (formatter) {
    return formatter(value as T) ?? placeholder;
  }

  if (value === null || value === undefined || value === "") {
    return placeholder;
  }

  if (Array.isArray(value)) {
    return value.length === 0 ? placeholder : value.join(",");
  }

  if (typeof value === "object") {
    return Object.keys(value ?? {}).length === 0 ? placeholder : JSON.stringify(value);
  }

  return String(value);
};
